<template>
    <Main class="data-view-list">
        <box-loading v-if="isLoading"></box-loading>
        <template v-else>
            <!--START:Box Filter-->
            <div class="mb-4" v-if="!isAccountAdmin && showBoxFilter">
                <FormFilter :list-fields-keys="listFieldsKeys" :is-account-admin="isAccountAdmin" :app-id="appId" :workspace-uid="workspaceUid"></FormFilter>
            </div>
            <!--END:Box Filter-->
            <div class="input-kintone">
                <template v-if="isAccountAdmin">
                    <el-row :gutter="20">
                        <el-col :span="20" :xs="24">
                            <el-col :span="12" :xs="24">
                                <InputField :span-input="16" :span-label="8" classes="mb-sm-3 mb-1" is-required :label-text="$t('textCommon.space')">
                                    <InputText :value="dataShare && dataShare['data_workspace'] && dataShare['data_workspace'].name ? dataShare['data_workspace'].name : ''"></InputText>
                                </InputField>

                                <InputField :span-input="16" :span-label="8" classes="mb-sm-3 mb-1" is-required :label-text="$t('textCommon.app')">
                                    <InputText :value="dataShare?.app_name ?? ''"></InputText>
                                </InputField>
                            </el-col>
                            <el-col :span="12" class="pl-sm-5 pl-2" :xs="24">
                                <InputField classes="mb-sm-3 mb-1" :span-input="20" :span-label="4" is-required :label-text="$t('member.list')">
                                    <InputText :value="dataShare?.view_name ?? ''"></InputText>
                                </InputField>

                                <InputField :span-label="4" :span-input="20" :label-text="$t('member.role')">
                                    <div class="box-roles-user box-roles-user__disabled">
                                        <label class="ckbox mb-0" v-for="roleItem in listRoles" :key="roleItem.value">
                                            <input v-model="roleUser" disabled type="checkbox" :value="roleItem.value" />
                                            <span>{{ $t(roleItem.label) }}</span>
                                        </label>
                                    </div>
                                </InputField>
                            </el-col>
                            <el-col :span="24" :xs="24">
                              <InputField :span-label="4" :span-input="20" :label-text="$t('member.filter')">
                                <div class="text-filter">{{ filterText }}</div>
                              </InputField>
                            </el-col>
                        </el-col>

                        <InputHandle
                            :is-account-admin="isAccountAdmin"
                            :role-user="roleUser"
                            @show-box-filter="onShowBoxFilter"
                            @reset-data-link="handleGetDetailDataShare"
                            :query-filter-kintone="queryFilterKintone"
                            :list-fields-keys="listFieldsKeys"
                            :data-share="dataShare"
                        ></InputHandle>
                    </el-row>
                </template>
                <template v-else>
                    <el-row :gutter="20">
                        <InputHandle
                            :is-account-admin="isAccountAdmin"
                            :role-user="roleUser"
                            @show-box-filter="onShowBoxFilter"
                            @reset-data-link="handleGetDetailDataShare"
                            :query-filter-kintone="queryFilterKintone"
                            :list-fields-keys="listFieldsKeys"
                            :data-share="dataShare"
                        ></InputHandle>
                    </el-row>
                </template>
                <div class="table-sm table-kb table-data-view" v-loading="isTableLoading">
                    <table class="table custom-table table-hover table-common">
                        <thead>
                            <tr class="clear-table">
                                <th v-for="key in listFieldsKeys" :key="key">
                                    <div v-if="checkFieldTotal(key)" class="p-2">
                                        <div class="d-flex flex-row justify-content-between mb-3">
                                            <span>合計:</span>
                                            <span>{{ mappingTotalData(getTotalData(key).total, listFields[key]) }}</span>
                                        </div>
                                        <div class="d-flex flex-row justify-content-between">
                                            <span>平均:</span>
                                            <span>{{ mappingTotalData(getTotalData(key).average, listFields[key]) }}</span>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            <tr class="header-text">
                                <th class="w-10"></th>
                                <th v-for="item in listFieldsKeys" :key="item + 'header-text'" class="has-action" :class="{ 'sort-active': item === sort.field }">
                                    <div class="d-flex th-sort justify-content-sm-between">
                                        {{ listFields[item].label }}
                                        <span class="sort-item ml-1" v-if="TYPE_SORT.includes(listFields[item].type)" @click="handleSort(item)">
                                            <i class="el-icon-top" :class="{ 'sort-active': item === sort.field && sort.order === 'asc' }"></i>
                                            <i class="el-icon-bottom" :class="{ 'sort-active': item === sort.field && sort.order === 'desc' }"></i>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="listDataShares && listDataShares.length > 0">
                                <tr v-for="(record, indexRecord) in listDataShares" :key="indexRecord + 'share'" class="row-kintone">
                                    <td class="text-sm-center text-left col-after-sm">
                                        <Button classes="btn-xs px-2" @click="onShowActionRecord($event, record)" type="outline-primary">
                                            <el-icon class="el-icon-document"></el-icon>
                                            {{ $t('button.detail') }}
                                        </Button>
                                    </td>
                                    <td v-for="(itemRecord, keyItemRecord) in record.data" :data-title="itemRecord.title" :key="keyItemRecord + 'item'">
                                        <div class="content-record">
                                            <div v-if="itemRecord.value.type === 'RICH_TEXT'" v-html="itemRecord.content_data"></div>
                                            <div
                                                style="cursor: pointer"
                                                :title="$t('button.preview')"
                                                @click="onShowSubTable(itemRecord.value, itemRecord.field, itemRecord.title)"
                                                v-else-if="itemRecord.value.type === 'SUBTABLE'"
                                            >
                                                {{ itemRecord.content_data }}
                                            </div>
                                            <div
                                                v-else-if="
                                                    itemRecord.value.type === 'NUMBER' ||
                                                    (itemRecord.value.type === 'CALC' && itemRecord.format == 'NUMBER_DIGIT') ||
                                                    (itemRecord.value.type === 'CALC' && itemRecord.format == 'NUMBER')
                                                "
                                                class="text-right"
                                            >
                                                {{ mapItemRecord(itemRecord) }}
                                            </div>
                                            <div v-else>{{ mapItemRecord(itemRecord) }}</div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td v-if="!isTableLoading" :colspan="listFieldsKeys.length + 1">
                                    <el-empty :description="$t('member.msgNoDataSearch')"></el-empty>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pagination-old clearfix">
                    <div class="pagination__items clearfix">
                        <span class="pagination__items__label">
                            {{ $t('paginator.itemsPerPage') }}
                        </span>
                        <el-select v-model="limit" class="pagination__items__select" @change="onChangeLimit">
                            <el-option v-for="value in perPageList" :key="value" :label="`${value}`" :value="value">
                                {{ value }}
                            </el-option>
                        </el-select>
                    </div>
                    <div class="pagination-old__paginator mt-3 mt-sm-0">
                        <ul class="clearfix mb-0">
                            <li @click="prevPage()">
                                <a href="javascript:void(0)" class="box-left" :class="{ disabled: numberOrder === 0 }">
                                    <i class="el-icon-d-arrow-left"></i>
                                </a>
                            </li>
                            <li class="active">
                                <a href="javascript:void(0)">
                                    {{ page }}
                                </a>
                            </li>
                            <li @click="nextPage()">
                                <a href="javascript:void(0)" class="box-right" :class="{ disabled: listDataShares.length < limit }">
                                    <i class="el-icon-d-arrow-right"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
        <template #bottomAction>
            <div class="text-right">
                <Button @click="handleCancelList" type="warning">{{ $t('button.cancel') }}</Button>
            </div>
        </template>
        <popup :show.sync="isShowDataTable" :title="titlePopupSubTable" modal-large>
            <template #content>
                <div class="table-sm table-kb" v-if="tableViewCurrent && listFieldSubTable">
                    <table class="table customer-table table-hover table-common">
                        <thead>
                            <tr>
                                <th
                                    :key="indexTitle"
                                    v-for="(title, indexTitle) in listFieldSubTable.map((elm) => {
                                        return elm.label;
                                    })"
                                >
                                    {{ title }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="tableViewCurrent && tableViewCurrent.length > 0">
                                <tr class="row-kintone" v-for="itemRow in tableViewCurrent" :key="itemRow.id">
                                    <td class="py-3" v-for="(itemField, indexF) in Object.assign(itemRow.value)" :key="indexF + '' + itemRow.id">
                                        {{ getValueFieldSubTable(itemField) }}
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td :colspan="listFieldSubTable.length" class="text-center px-2">
                                    <el-empty :description="titlePopupSubTable + ' No Data'"></el-empty>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template #footer>
                <Button @click="isShowDataTable = false" type="warning" classes="btn-sm">
                    {{ $t('button.cancel') }}
                </Button>
            </template>
        </popup>
    </Main>
</template>

<script>
import { mapState } from 'vuex';
import { returnItemWithUnit, mapListFieldView, mapDataRecord } from './index';
import { addComasNumber, formatDateTime, formatNumber, numberFormat } from '@/utils';
import { TYPE_CHECK_BOX, TYPE_CONTENT_DATE, TYPE_CONTENT_TEXT, TYPE_DATE_TIME, TYPE_MULTI_SELECT, PER_PAGE_LIST, TYPE_SORT } from '@/config/constants';
import Main from '@/components/partials/layout/Main';
import InputHandle from '@/views/share/dataView/list/inputHandle.vue';
import FormFilter from '../formFilter/index.vue';
import Button from '@/components/partials/Button';
import InputField from '@/components/partials/InputField';
import InputText from '@/components/partials/customs/InputText';
import BoxLoading from '@/components/partials/BoxLoading';
import Popup from '@/components/partials/Popup';

export default {
    components: {
        BoxLoading,
        InputText,
        InputField,
        Main,
        Button,
        Popup,
        FormFilter,
        InputHandle
    },
    data() {
        return {
            TYPE_SORT,
            isShowDataTable: false,
            isAccountAdmin: false,
            tableViewCurrent: [],
            listFieldSubTable: [],
            titlePopupSubTable: '',
            roleUser: ['detail', '', '', ''],
            dataShare: null,
            isLoading: false,
            isTableLoading: false,
            listDataShares: [],
            listFields: [],
            listFieldsKeys: [],
            // filter
            showBoxFilter: false,
            appId: '',
            workspaceUid: '',
            // page
            numberOrder: 0,
            page: 1,
            limit: 10,
            sort: {
                field: '',
                order: ''
            },
            queryFilterKintone: null,
            perPageList: PER_PAGE_LIST,
            arrayFieldView: null
        };
    },
    computed: {
        ...mapState('auth', ['userInfo']),
        ...mapState('share', ['isCallFilter', 'isFilter', 'queryFilter']),
        listRoles() {
            return [
                { label: 'member.roles.view', value: 'detail' },
                { label: 'member.roles.edit', value: 'update' },
                { label: 'member.roles.register', value: 'create' }
            ];
        },
        listAllTypes() {
            return [
                { value: '=', label: this.$t('filter.condition1') },
                { value: '!=', label: this.$t('filter.condition2') },
                { value: 'in', label: this.$t('filter.condition3') },
                { value: 'not in', label: this.$t('filter.condition4') },
                { value: 'like', label: this.$t('filter.condition5') },
                { value: 'not like', label: this.$t('filter.condition6') },
                { value: '<=', label: this.$t('filter.condition7') },
                { value: '<', label: this.$t('filter.condition8') },
                { value: '>=', label: this.$t('filter.condition9') },
                { value: '>', label: this.$t('filter.condition10') }
            ];
        },

        isRoleUpdate() {
            return this.roleUser.includes('update');
        },
        filterText() {
            let textResult = '';
            let { listFields, dataShare } = this;
            let dataFilter = dataShare?.array_filter ?? [];
            let typeFilter = dataShare?.data_filter && dataShare?.data_filter.includes(' or ') ? 'or' : 'and';
            if (listFields) {
                if (dataFilter.length === 0) {
                    textResult = this.$t('filter.allRecord');
                } else {
                    dataFilter.map((elm, index) => {
                        if (elm.field) {
                            textResult += listFields[elm.field] ? listFields[elm.field].label : '';
                            let typeIndex = this.listAllTypes.findIndex((type) => type.value === elm.type);
                            if (typeIndex >= 0) {
                                textResult += `    ${this.listAllTypes[typeIndex].label}   `;
                            }
                            if (elm.value && Array.isArray(elm.value)) {
                                textResult += ` (${elm.value.join(' , ')}) `;
                            } else {
                                textResult += ` ${elm.value} `;
                            }
                            if (index < dataFilter.length - 1) {
                                textResult += ` ${typeFilter} `;
                            }
                        }
                    });
                }
            }
            return textResult;
        }
    },
    watch: {
        userInfo: {
            immediate: true,
            handler: function (val) {
                if (this.userInfo) {
                    let user = this.userInfo;
                    if (user) {
                        let roleUser = parseInt(user.type);
                        this.isAccountAdmin = roleUser === 2;
                    }
                }
            }
        },
        isCallFilter: {
            handler: function (val) {
                this.queryFilterKintone = this.queryFilter;
                this.handleGetDataShares();
            }
        }
    },
    created() {
        if (this.$route.query.page) this.page = Number(this.$route.query.page);
        if (this.$route.query.limit) this.limit = Number(this.$route.query.limit);
        if (this.$route.query.numberOrder) this.numberOrder = Number(this.$route.query.numberOrder);
        this.handleGetDetailDataShare();
    },
    methods: {
        mapItemRecord(itemRecord) {
            return returnItemWithUnit(itemRecord.content_data, itemRecord?.unit, itemRecord?.unitPosition);
        },
        mappingTotalData(itemData, itemField) {
            return returnItemWithUnit(itemData, itemField?.unit, itemField?.unitPosition);
        },

        checkFieldTotal(key) {
            if (
                this.listFields[key].type === 'NUMBER' ||
                (this.listFields[key].type === 'CALC' && this.listFields[key].format === 'NUMBER') ||
                (this.listFields[key].type === 'CALC' && this.listFields[key].format === 'NUMBER_DIGIT')
            )
                return true;
            return false;
        },
        handleSort(field) {
            let originOrder = this.sort.field === field ? this.sort.order : '';
            let order;
            switch (originOrder) {
                case 'asc':
                    order = 'desc';
                    break;
                case 'desc':
                    order = '';
                    field = '';
                    break;
                default:
                    order = 'asc';
            }
            this.sort.field = field;
            this.sort.order = order;
            this.handleGetDataShares();
        },
        onShowActionRecord(event, row) {
            const isNewTab = event?.ctrlKey || event?.metaKey;
            this.isRoleUpdate || this.isAccountAdmin ? this.onEditRecord(row, isNewTab) : this.onDetailRecord(row, isNewTab);
        },
        onDetailRecord(row, isNewTab = false) {
            const idRecord = row['id'].value;
            const { id, idDataLink = '', linkName = '' } = this.$route.query;
            const name = this.isAccountAdmin && this.$router.currentRoute.name === 'dataLinkMultiDataView' ? 'dataLinkMultiDataViewDetail' : 'dataViewDetailChildren';
            let routeConfig = {
                name,
                query: {
                    idShare: id,
                    idRecord,
                    idDataLink,
                    update: this.isRoleUpdate ? 1 : 0,
                    link_name: linkName,
                    page: this.page,
                    limit: this.limit,
                    numberOrder: this.numberOrder
                }
            };
            if (isNewTab) {
                let routeData = this.$router.resolve(routeConfig);
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push(routeConfig);
            }
        },
        onEditRecord(row, isNewTab = false) {
            const idRecord = row['id'].value;
            const { id, idDataLink, linkName } = this.$route.query;
            let pathMapping = {
                '/share/data-view': '/share/data-view/edit',
                '/data-link-multi/data-view': '/data-link-multi/data-view/edit',
                '/share-user-children/data-view': '/share-user-children/data-view/edit'
            };
            let pathEdit = pathMapping[this.$router.currentRoute.path] || '/share/data-view/edit';
            let routeConfig = {
                path: pathEdit,
                query: {
                    idShare: id,
                    idRecord,
                    idDataLink,
                    link_name: linkName,
                    page: this.page,
                    limit: this.limit,
                    numberOrder: this.numberOrder
                }
            };
            if (isNewTab) {
                let routeData = this.$router.resolve(routeConfig);
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push(routeConfig);
            }
        },
        handleCancelList() {
            let typeAdmin = this.userInfo && this.userInfo.type === 2;
            if (typeAdmin) {
                this.$router.push({
                    name: this.$router.currentRoute.name === 'dataLinkMultiDataView' ? 'viewDataLinkMulti' : 'shareList',
                    query: {
                        id: this.$route.query.idDataLink,
                        link_name: this.$route.query.link_name ?? ''
                    }
                });
            } else {
                this.$router.push({
                    name: 'shareListUserChildren'
                });
            }
        },
        onShowEditRecord(row) {
            let idRecord = row['id'].value;
            let queryId = this.$route.query.id;

            this.$router.push({
                name: this.isAccountAdmin ? (this.$router.currentRoute.name === 'dataLinkMultiDataView' ? 'dataLinkMultiDataViewEdit' : 'dataViewEdit') : 'dataViewEditChildren',
                query: {
                    idShare: queryId,
                    idRecord: idRecord,
                    idDataLink: this.$route.query.idDataLink ?? '',
                    link_name: this.$route.query.link_name ?? '',
                    page: this.page,
                    limit: this.limit,
                    numberOrder: this.numberOrder
                }
            });
        },
        onShowBoxFilter() {
            console.log('filet');
            this.showBoxFilter = !this.showBoxFilter;
        },

        handleGetDetailDataShare() {
            this.isLoading = true;
            let successCallback = (response) => {
                this.dataShare = response.data?.data?.data;
                this.appId = this.dataShare?.app_id;
                this.workspaceUid = this.dataShare?.workspace_uid;
                this.arrayFieldView = this.isAccountAdmin ? null : this.dataShare?.array_field_view;
                this.roleUser = this.dataShare?.list_role
                    ?.filter((elm) => elm.enable)
                    .map((elm) => {
                        return elm.type;
                    });
                this.handleGetDataShares();
                this.isLoading = false;
            };

            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                id: this.$route.query.id
            };
            this.$store.dispatch('connect/getDetailConnect', payload);
        },
        handleGetDataShares() {
            this.isTableLoading = true;
            let successCallback = (response) => {
                let { data } = response.data.data;
                this.listFields = mapListFieldView(data.fields, this.arrayFieldView);
                this.listFieldsKeys = Object.keys(this.listFields);
                this.listDataShares = mapDataRecord(data.records ?? [], this.listFieldsKeys, this.listFields);
                this.isTableLoading = false;
            };

            let errorCallback = () => {
                this.isTableLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                shareId: this.$route.query.id,
                query: this.getQueryString()
            };
            this.$store.dispatch('share/getListShareData', payload);
        },
        onShowSubTable(tableData, keyTable, titleTable) {
            if (keyTable) {
                let fields = this.listFields && this.listFields[keyTable] ? this.listFields[keyTable].fields : {};
                this.listFieldSubTable = [];
                Object.keys(fields).map((key) => {
                    let objItem = {
                        code: key,
                        label: fields[key].label
                    };
                    this.listFieldSubTable.push(objItem);
                });
            }
            this.titlePopupSubTable = titleTable;
            this.isShowDataTable = true;
            this.tableViewCurrent = tableData;
        },
        getValueFieldSubTable(item) {
            let typeField = item.type;
            let result = '';
            if (TYPE_CONTENT_TEXT.includes(typeField)) {
                result = item.value;
                if ([TYPE_MULTI_SELECT, TYPE_CHECK_BOX].includes(typeField)) {
                    result = item.value ? item.value.replaceAll(';', ', ') : '';
                }
            } else if (TYPE_CONTENT_DATE.includes(typeField)) {
                result = typeField === TYPE_DATE_TIME ? formatDateTime(item.value, 'YYYY/MM/DD HH:mm') : formatDateTime(item.value, 'YYYY/MM/DD');
            } else if (typeField === 'NUMBER' && item.value) {
                result = addComasNumber(Number(item.value));
            } else {
                result = item.value;
            }
            return result;
        },
        getTotalData(keyTitle) {
            let totalNumber = 0;
            let totalLength = 0;
            this.listDataShares.forEach((record) => {
                record.data.forEach((item) => {
                    if (keyTitle === item.field) {
                        totalNumber += +formatNumber(item.content_data);
                        totalLength++;
                    }
                });
            });
            return {
                total: numberFormat.numberJPScreen(totalNumber),
                average: totalNumber && totalLength ? numberFormat.numberJPScreen(Math.floor(totalNumber / totalLength)) : 0
            };
        },
        getQueryString() {
            let query = [`last_id=${this.numberOrder}`, `limit=${this.limit}`];
            if (this.sort.field) {
                query.push(`sort=${this.sort.field}%20${this.sort.order}`);
            }
            if (this.queryFilterKintone) {
                query.push(`filters=${this.queryFilterKintone}`);
            }
            return query.join('&');
        },
        updateRouterQuery() {
            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('page', this.page);
            currentUrl.searchParams.set('limit', this.limit);
            currentUrl.searchParams.set('numberOrder', this.numberOrder);
            window.history.replaceState(null, '', currentUrl.toString());
        },
        prevPage() {
            if (this.numberOrder && this.numberOrder !== 0) {
                this.numberOrder = this.numberOrder - this.limit;
                this.page -= 1;
                this.updateRouterQuery();
                this.handleGetDataShares();
            }
        },
        nextPage() {
            let lengthData = this.listDataShares.length || 0;
            if (this.numberOrder !== null && lengthData === this.limit) {
                this.page += 1;
                this.numberOrder = this.numberOrder + this.limit;
                this.updateRouterQuery();
                this.handleGetDataShares();
            }
        },
        onChangeLimit() {
            this.numberOrder = 0;
            this.page = 1;
            this.updateRouterQuery();
            this.handleGetDataShares();
        }
    },
    destroyed() {
        this.$store.commit('share/resetFilter', {
            data: []
        });
    }
};
</script>
